const vhUnit = () => {
	document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
	document.documentElement.style.setProperty('--vw', `${document.body.clientWidth * 0.01}px`);
	document.documentElement.style.setProperty('--menuHeight', `${document.querySelector('.main-header').offsetHeight}px`);
};

export default vhUnit;
